// Imports
var ___HTML_LOADER_IMPORT_0___ = new URL("/campaign/risoku20231204/image/banner_point-risoku-7_750x400.webp.png", import.meta.url);
var ___HTML_LOADER_IMPORT_1___ = new URL("/common/jquery-3.6.0.min.js", import.meta.url);
var ___HTML_LOADER_IMPORT_2___ = new URL("/common/jquery.query.js", import.meta.url);
var ___HTML_LOADER_IMPORT_3___ = new URL("/common/jquery.json.min.js", import.meta.url);
var ___HTML_LOADER_IMPORT_4___ = new URL("/common/default.scss", import.meta.url);
var ___HTML_LOADER_IMPORT_5___ = new URL("/campaign/risoku20231204/index.scss", import.meta.url);
var ___HTML_LOADER_IMPORT_6___ = new URL("/common/timer.js", import.meta.url);
var ___HTML_LOADER_IMPORT_7___ = new URL("/common/Accordion.js", import.meta.url);
var ___HTML_LOADER_IMPORT_8___ = new URL("/common/Modal.js", import.meta.url);
var ___HTML_LOADER_IMPORT_9___ = new URL("/campaign/risoku20231204/component/Modal.js", import.meta.url);
var ___HTML_LOADER_IMPORT_10___ = new URL("/common/header.js", import.meta.url);
var ___HTML_LOADER_IMPORT_11___ = new URL("/component/two-word/const.js", import.meta.url);
var ___HTML_LOADER_IMPORT_12___ = new URL("/component/two-word/two-word.js", import.meta.url);
var ___HTML_LOADER_IMPORT_13___ = new URL("/common/header.scss", import.meta.url);
var ___HTML_LOADER_IMPORT_14___ = new URL("/component/two-word/submenu.js", import.meta.url);
var ___HTML_LOADER_IMPORT_15___ = new URL("/component/two-word/two-word.scss", import.meta.url);
var ___HTML_LOADER_IMPORT_16___ = new URL("/common/menu_li.scss", import.meta.url);
var ___HTML_LOADER_IMPORT_17___ = new URL("/component/two-word/guidemenu.js", import.meta.url);
var ___HTML_LOADER_IMPORT_18___ = new URL("/component/two-word/two-word_results.scss", import.meta.url);
var ___HTML_LOADER_IMPORT_19___ = new URL("/common/sitepolicy.scss", import.meta.url);
var ___HTML_LOADER_IMPORT_20___ = new URL("/component/infoarea.scss", import.meta.url);
var ___HTML_LOADER_IMPORT_21___ = new URL("/campaign/risoku20230123/component/modal.scss", import.meta.url);
var ___HTML_LOADER_IMPORT_22___ = new URL("/campaign/risoku20231204/image/banner_point-risoku-7_800x800.webp.png", import.meta.url);
var ___HTML_LOADER_IMPORT_23___ = new URL("/campaign/risoku20231204/component/entry_section.scss", import.meta.url);
var ___HTML_LOADER_IMPORT_24___ = new URL("/campaign/risoku20231204/component/entry_decoration.scss", import.meta.url);
var ___HTML_LOADER_IMPORT_25___ = new URL("/campaign/risoku20231204/component/entry_button.scss", import.meta.url);
var ___HTML_LOADER_IMPORT_26___ = new URL("/campaign/risoku20231204/component/requirements.scss", import.meta.url);
var ___HTML_LOADER_IMPORT_27___ = new URL("/campaign/risoku20231204/component/share.scss", import.meta.url);
var ___HTML_LOADER_IMPORT_28___ = new URL("/campaign/risoku20230123/image/overview_copy_illustration_pc.webp.png", import.meta.url);
var ___HTML_LOADER_IMPORT_29___ = new URL("/campaign/risoku20230123/image/overview_copy_illustration_sp.webp.png", import.meta.url);
var ___HTML_LOADER_IMPORT_30___ = new URL("/campaign/risoku20231204/component/_categorylist-link.scss", import.meta.url);
var ___HTML_LOADER_IMPORT_31___ = new URL("/campaign/risoku20231204/image/step1.webp.png", import.meta.url);
var ___HTML_LOADER_IMPORT_32___ = new URL("/campaign/risoku20231204/image/step3.webp.png", import.meta.url);
var ___HTML_LOADER_IMPORT_33___ = new URL("/campaign/risoku20231204/image/step4.webp.png", import.meta.url);
var ___HTML_LOADER_IMPORT_34___ = new URL("/campaign/risoku20231204/image/step5.webp.png", import.meta.url);
var ___HTML_LOADER_IMPORT_35___ = new URL("/common/ui-parts/breadcrumbs.scss", import.meta.url);
var ___HTML_LOADER_IMPORT_36___ = new URL("/common/footer.scss", import.meta.url);
// Module
var code = `<!DOCTYPE html>
<html lang="ja">
  <head
    prefix="og: https://ogp.me/ns# fb: https://ogp.me/ns/ fb# article: https://ogp.me/ns/article#"
  >
    
    <!---->
    <!--デフォルト値の設定-->




<meta charset="UTF-8" />
<meta
  name="viewport"
  content="width=device-width,user-scalable=no,initial-scale=1,maximum-scale=1"
/>
<meta name="format-detection" content="telephone=no" />
<title>Pontaポイント定期預金キャンペーン｜【Ponta】お金のミカタ</title>
<meta name="description" content="ポイントがかならず増えて戻ってくる！ポイントを預けて待つだけの、簡単ポン活キャンペーン実施中。さらにクイズが当たれば利率UPのチャンス！詳細はキャンペーンページをチェック♪" />
<link rel="index" href="index.htm" />
<!-- icon -->
<link
  rel="shortcut icon"
  type="image/vnd.microsoft.icon"
  href="/cmn/img/favicon.ico"
/>
<link rel="icon" type="image/x-icon" href="/cmn/img/favicon.ico" />
<link
  rel="apple-touch-icon"
  sizes="180x180"
  href="/cmn/img/apple-touch-icon.png"
/>
<!-- og -->
<meta property="og:url" content="https://www.finance.ponta.jp/campaign/risoku20231204/" />
<meta property="og:type" content="website" />
<meta property="og:title" content="Pontaポイント定期預金キャンペーン｜【Ponta】お金のミカタ" />
<meta property="og:description" content="ポイントがかならず増えて戻ってくる！ポイントを預けて待つだけの、簡単ポン活キャンペーン実施中。さらにクイズが当たれば利率UPのチャンス！詳細はキャンペーンページをチェック♪" />
<meta property="og:site_name" content="【Ponta】お金のミカタ" />
<meta property="og:image" content="${___HTML_LOADER_IMPORT_0___}" />
<!-- Twitter -->
<meta name="twitter:card" content="summary_large_image" />
<meta name="twitter:site" content="@Ponta" />

${"<" + "script"} type="text/javascript" src="${___HTML_LOADER_IMPORT_1___}">${"<" + "/script"}>
${"<" + "script"} type="text/javascript" src="${___HTML_LOADER_IMPORT_2___}">${"<" + "/script"}>
${"<" + "script"} type="text/javascript" src="${___HTML_LOADER_IMPORT_3___}">${"<" + "/script"}>

<!-- StyleSheet -->
<link rel="stylesheet" href="${___HTML_LOADER_IMPORT_4___}" />

<!-- noto sans jp の読み込み -->
<link rel="preconnect" href="https://fonts.gstatic.com" />
<link
  rel="preload"
  href="https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@100;300;400;500;700;900&display=swap"
  as="style"
/>
<link
  rel="stylesheet"
  href="https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@100;300;400;500;700;900&display=swap"
  media="print"
  onload="this.media = 'all'"
/>

<!-- corporate-logo の読み込み -->
<link rel="preload" href="/font/corporate-logo.css" as="style" />
<link
  rel="stylesheet"
  href="/font/corporate-logo.css"
  media="print"
  onload="this.media = 'all'"
/>

<!-- Google Tag Manager (loadイベント後に遅延読み込み) -->
<!-- 旧コード: Clarityとアニメーションの競合解消後に戻す
${"<" + "script"}>
  (function (w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
    var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s),
      dl = l != "dataLayer" ? "&l=" + l : "";
    j.async = true;
    j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
    f.parentNode.insertBefore(j, f);
  })(window, document, "script", "dataLayer", "GTM-P3QVP6P");
${"<" + "/script"}>
-->
${"<" + "script"}>
  window.dataLayer = window.dataLayer || [];
  window.addEventListener("load", function () {
    dataLayer.push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
    var f = document.getElementsByTagName("script")[0],
      j = document.createElement("script");
    j.async = true;
    j.src = "https://www.googletagmanager.com/gtm.js?id=GTM-P3QVP6P";
    f.parentNode.insertBefore(j, f);
  });
${"<" + "/script"}>

<!-- Google広告 -->
${"<" + "script"}
  async
  src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-2528660706528280"
  crossorigin="anonymous"
>${"<" + "/script"}>


    <link rel="canonical" href="https://www.finance.ponta.jp/campaign/risoku20231204/" />
    <link rel="stylesheet" href="${___HTML_LOADER_IMPORT_5___}" />

    ${"<" + "script"} type="text/javascript" src="${___HTML_LOADER_IMPORT_6___}">${"<" + "/script"}>
    ${"<" + "script"} type="text/javascript" src="${___HTML_LOADER_IMPORT_7___}">${"<" + "/script"}>
    ${"<" + "script"} type="text/javascript" src="${___HTML_LOADER_IMPORT_8___}">${"<" + "/script"}>
    ${"<" + "script"}
      type="text/javascript"
      src="${___HTML_LOADER_IMPORT_9___}"
    >${"<" + "/script"}>
  </head>

  <body>
    <!-- prettier-ignore -->
    <!-- Google Tag Manager (noscript) -->
<noscript
  ><iframe
    src="https://www.googletagmanager.com/ns.html?id=GTM-P3QVP6P"
    height="0"
    width="0"
    style="display: none; visibility: hidden"
  ></iframe
></noscript>
<!-- End Google Tag Manager (noscript) -->

    <link
  rel="stylesheet"
  href="https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css"
/>
${"<" + "script"} src="https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js">${"<" + "/script"}>
<!--タイマー読み込み-->
${"<" + "script"} src="${___HTML_LOADER_IMPORT_6___}">${"<" + "/script"}>
${"<" + "script"} type="text/javascript" src="${___HTML_LOADER_IMPORT_10___}">${"<" + "/script"}>
${"<" + "script"} type="text/javascript" src="${___HTML_LOADER_IMPORT_11___}">${"<" + "/script"}>
${"<" + "script"} type="text/javascript" src="${___HTML_LOADER_IMPORT_12___}">${"<" + "/script"}>
<link rel="stylesheet" href="${___HTML_LOADER_IMPORT_13___}" />

<header>
  <nav id="header-inner">
    <a id="ponta-logo" data-id="header-mikata_Ponta-logo" href="/">
      <img
        src="/cmn/img/logo_okaneponta.svg"
        alt="Ponta"
        width="59"
        height="13"
      />
    </a>
    <ul class="global-menu">
      <li class="tab-list-item mikata active_tab">
        <h1 id="site-title">
          <a href="/" data-id="header-mikata_tabmenu_mikata">お金のミカタ</a>
        </h1>
      </li>
      <li class="tab-list-item column">
        <a
          href="https://column.finance.ponta.jp/"
          data-id="header-mikata_tabmenu_column"
          >ミカタイムズ</a
        >
      </li>
    </ul>
  </nav>
  <nav id="sub_menu">
    <div class="sub-list-wrapper">
      <ul class="sub-list">
        <li class="sub-list-item">
          <a href="/mottainai/" data-id="hamburger_mottainai">もったいない</a>
        </li>
        <li class="sub-list-item">
          <a href="/money-ponkatsu/" data-id="hamburger_money-ponkatsu"
            >マネPon</a
          >
        </li>
        <li class="sub-list-item">
          <a href="/fortune/" data-id="hamburger_fortune">金運</a>
        </li>
        <li class="sub-list-item">
          <a href="/money/" data-id="hamburger_ponta-finance">銀行証券</a>
        </li>
        <li class="sub-list-item">
          <a href="/insurance/" data-id="hamburger_hoken">保険</a>
        </li>
      </ul>
    </div>
    <div class="sub-menu-two-words">
      
${"<" + "script"} type="text/javascript" src="${___HTML_LOADER_IMPORT_14___}">${"<" + "/script"}>
  

<link rel="stylesheet" href="${___HTML_LOADER_IMPORT_15___}" />

<div id="sub-menu_two-words">
  <div id="sub-menu_first_word__dropdown" class="dropdown">
    <div
      id="sub-menu_first_word__toggle"
      class="first_word__toggle dropdown__toggle"
    >
      <span>➀ やりたいこと</span>
    </div>
    <div id="sub-menu_first_word__menu-base" class="menu-base">
      <ul
        id="sub-menu_first_word__menu"
        class="dropdown__menu first_word__menu"
        data-id="header-mikata_navimenu_search1"
      >
        <li class="option disabled">① やりたいことを選択 ▼</li>
      </ul>
    </div>
  </div>
  <div id="sub-menu_second_word__dropdown" class="dropdown">
    <div id="sub-menu_second_word__toggle" class="dropdown__toggle">
      <span>➁ どうやって？</span>
    </div>
    <div id="sub-menu_second_word__menu-base" class="menu-base">
      <ul
        id="sub-menu_second_word__menu"
        class="dropdown__menu second_word__menu"
        data-id="header-mikata_navimenu_search2"
      >
        <li class="option disabled">➁ どうやって？ ▼</li>
      </ul>
    </div>
  </div>
</div>

    </div>
    <div class="guide-menu-container">
      <input
        id="drawer_input"
        class="drawer_hidden"
        type="checkbox"
        data-id="header-mikata_openmenu"
      />
      <label for="drawer_input" class="guide-menu-open">
        <img src="/cmn/img/hamburger.svg" width="28.5" height="18" />
        <span>MENU</span>
      </label>
      <div id="guide-menu">
        <div class="guide-menu-wrapper">
          <div class="guide-menu-header">
            <div class="guide-menu-title">
              <a href="/">
                <img
                  src="/cmn/img/logo_menu-mikata.svg"
                  alt="Ponta お金のミカタ"
                  　width="260"
                  height="27"
                />
              </a>
            </div>
            <label for="drawer_input" class="guide-menu-close">
              <img src="/cmn/img/close.svg" />
              <span>CLOSE</span>
            </label>
          </div>
          <ul class="category_list">
            <!-- prettier-ignore -->
            <link rel="stylesheet" href="${___HTML_LOADER_IMPORT_16___}" />
<li>
  <a
    class="category_title"
    href="/mottainai/"
    data-id="hamburger_mottainai"
    target=""
    rel=""
  >
    知らないなんてもったいない！
  </a>
  
  <input
    id="drawer-ponta_10"
    class="drawer_input_category drawer_hidden"
    type="checkbox"
    onchange="toggleValue(this)"
  />
  <label for="drawer-ponta_10" class="drawer_open">
    <span id="drawer_span_10">＋</span>
  </label>
  <ul id="menu2_10" class="menu2">
    
    <li>
      <a
        href="/mottainai/type/"
        data-id="hamburger_mottainai_type"
        target=""
        rel=""
        >もったいない診断</a
      >
    </li>
    
    <li>
      <a
        href="/mottainai/mufg/"
        data-id="hamburger_mottainai_mufg"
        target=""
        rel=""
        >三菱UFJ銀行</a
      >
    </li>
    
    <li>
      <a
        href="/mottainai/lawsonbank/atm/"
        data-id="hamburger_mottainai_lawsonbank_atm"
        target=""
        rel=""
        >ぽんたまATM</a
      >
    </li>
    
    <li>
      <a
        href="/mottainai/lawsonbank/credit/"
        data-id="hamburger_mottainai_lawsonbank_credit"
        target=""
        rel=""
        >ローソンPontaプラス</a
      >
    </li>
    
    <li>
      <a
        href="/mottainai/connect-sec/"
        data-id="hamburger_mottainai_connect-sec"
        target=""
        rel=""
        >大和コネクト証券</a
      >
    </li>
    
    <li>
      <a
        href="/mottainai/insurance/fp/"
        data-id="hamburger_mottainai_insurance_fp"
        target=""
        rel=""
        >ライフプラン表作成サービス</a
      >
    </li>
    
    <li>
      <a
        href="/mottainai/game/"
        data-id="hamburger_mottainai_game"
        target=""
        rel=""
        >金融ゲーム</a
      >
    </li>
    
    <li>
      <a
        href="/mottainai/rental-subsc/"
        data-id="hamburger_mottainai_rental-subsc"
        target=""
        rel=""
        >家電レンタルサービス（アリスプライム）</a
      >
    </li>
    
  </ul>
  
</li>

            <link rel="stylesheet" href="${___HTML_LOADER_IMPORT_16___}" />
<li>
  <a
    class="category_title"
    href="/money-ponkatsu/?from=hamburger_money-ponkatsu"
    data-id="hamburger_money-ponkatsu"
    target=""
    rel=""
  >
    マネPon（楽しみながらためる）
  </a>
  
  <input
    id="drawer-ponta_1"
    class="drawer_input_category drawer_hidden"
    type="checkbox"
    onchange="toggleValue(this)"
  />
  <label for="drawer-ponta_1" class="drawer_open">
    <span id="drawer_span_1">＋</span>
  </label>
  <ul id="menu2_1" class="menu2">
    
    <li>
      <a
        href="/2-choices/"
        data-id="hamburger_2-choices"
        target=""
        rel=""
        >2択でPonta</a
      >
    </li>
    
  </ul>
  
</li>

            <link rel="stylesheet" href="${___HTML_LOADER_IMPORT_16___}" />
<li>
  <a
    class="category_title"
    href="/money/"
    data-id="hamburger_ponta-finance"
    target=""
    rel=""
  >
    Pontaファイナンス
  </a>
  
  <input
    id="drawer-ponta_2"
    class="drawer_input_category drawer_hidden"
    type="checkbox"
    onchange="toggleValue(this)"
  />
  <label for="drawer-ponta_2" class="drawer_open">
    <span id="drawer_span_2">＋</span>
  </label>
  <ul id="menu2_2" class="menu2">
    
    <li>
      <a
        href="/money/#saving_point"
        data-id="hamburger_ponta-finance_saving_point"
        target=""
        rel=""
        >金融機関でポイントをためる</a
      >
    </li>
    
    <li>
      <a
        href="/money/#invest-trial_point"
        data-id="hamburger_ponta-finance_invest-trial_point"
        target=""
        rel=""
        >投資体験でポイントを増やす</a
      >
    </li>
    
    <li>
      <a
        href="/money/#invest_point"
        data-id="hamburger_ponta-finance_invest_point"
        target=""
        rel=""
        >ポイントをつかってリアル投資</a
      >
    </li>
    
  </ul>
  
</li>

<link rel="stylesheet" href="${___HTML_LOADER_IMPORT_16___}" />
<li>
  <a
    class="category_title"
    href="/insurance/"
    data-id="hamburger_hoken"
    target=""
    rel=""
  >
    Pontaの保険
  </a>
  
  <input
    id="drawer-ponta_3"
    class="drawer_input_category drawer_hidden"
    type="checkbox"
    onchange="toggleValue(this)"
  />
  <label for="drawer-ponta_3" class="drawer_open">
    <span id="drawer_span_3">＋</span>
  </label>
  <ul id="menu2_3" class="menu2">
    
    <li>
      <a
        href="/insurance/#insurance-easy"
        data-id="hamburger_hoken_kantan"
        target=""
        rel=""
        >1日から入れる保険</a
      >
    </li>
    
    <li>
      <a
        href="/insurance/#insurance-hokepon"
        data-id="hamburger_hoken_hokepon"
        target=""
        rel=""
        >Ponta会員限定保険</a
      >
    </li>
    
    <li>
      <a
        href="/insurance/#insurance-au-seimei"
        data-id="hamburger_hoken_au-seimei"
        target=""
        rel=""
        >ポイントがたまる生命保険</a
      >
    </li>
    
    <li>
      <a
        href="/insurance/#insurance-living"
        data-id="hamburger_hoken_living"
        target=""
        rel=""
        >暮らしの保険</a
      >
    </li>
    
    <li>
      <a
        href="/insurance/#insurance-pet"
        data-id="hamburger_hoken_pet"
        target=""
        rel=""
        >わんにゃん保険</a
      >
    </li>
    
  </ul>
  
</li>

            <link rel="stylesheet" href="${___HTML_LOADER_IMPORT_16___}" />
<li>
  <a
    class="category_title"
    href="/lifeplan/"
    data-id="hamburger_lifeplan"
    target=""
    rel=""
  >
    ライフプラン表作成サービス
  </a>
  
</li>

            <link rel="stylesheet" href="${___HTML_LOADER_IMPORT_16___}" />
<li>
  <a
    class="category_title"
    href="/diagnosis/"
    data-id="hamburger_400f"
    target=""
    rel=""
  >
    お金の相談窓口（オカネコ）
  </a>
  
</li>

<link rel="stylesheet" href="${___HTML_LOADER_IMPORT_16___}" />
<li>
  <a
    class="category_title"
    href="/fortune/"
    data-id="hamburger_fortune"
    target=""
    rel=""
  >
    星座＆タロット占い
  </a>
  
  <input
    id="drawer-ponta_6"
    class="drawer_input_category drawer_hidden"
    type="checkbox"
    onchange="toggleValue(this)"
  />
  <label for="drawer-ponta_6" class="drawer_open">
    <span id="drawer_span_6">＋</span>
  </label>
  <ul id="menu2_6" class="menu2">
    
    <li>
      <a
        href="/fortune/#horoscope-rank"
        data-id="hamburger_fortune_horoscope"
        target=""
        rel=""
        >今日の金運ランキング</a
      >
    </li>
    
    <li>
      <a
        href="/fortune/tarot/"
        data-id="hamburger_fortune_tarot"
        target=""
        rel=""
        >タロット占い</a
      >
    </li>
    
  </ul>
  
</li>

            <link rel="stylesheet" href="${___HTML_LOADER_IMPORT_16___}" />
<li>
  <a
    class="category_title"
    href="/campaign/"
    data-id="hamburger_campaign-list"
    target=""
    rel=""
  >
    キャンペーン一覧
  </a>
  
</li>

          </ul>
          <div class="guide-menu_two-words_container">
            <p>二言で検索</p>
             
${"<" + "script"} type="text/javascript" src="${___HTML_LOADER_IMPORT_17___}">${"<" + "/script"}>
 

<link rel="stylesheet" href="${___HTML_LOADER_IMPORT_15___}" />

<div id="guide-menu_two-words">
  <div id="guide-menu_first_word__dropdown" class="dropdown">
    <div
      id="guide-menu_first_word__toggle"
      class="first_word__toggle dropdown__toggle"
    >
      <span>➀ やりたいこと</span>
    </div>
    <div id="guide-menu_first_word__menu-base" class="menu-base">
      <ul
        id="guide-menu_first_word__menu"
        class="dropdown__menu first_word__menu"
        data-id="header-mikata_navimenu_search1"
      >
        <li class="option disabled">① やりたいことを選択 ▼</li>
      </ul>
    </div>
  </div>
  <div id="guide-menu_second_word__dropdown" class="dropdown">
    <div id="guide-menu_second_word__toggle" class="dropdown__toggle">
      <span>➁ どうやって？</span>
    </div>
    <div id="guide-menu_second_word__menu-base" class="menu-base">
      <ul
        id="guide-menu_second_word__menu"
        class="dropdown__menu second_word__menu"
        data-id="header-mikata_navimenu_search2"
      >
        <li class="option disabled">➁ どうやって？ ▼</li>
      </ul>
    </div>
  </div>
</div>

            <link rel="stylesheet" href="${___HTML_LOADER_IMPORT_18___}" />
<div
  id="guide-menu_search_results"
  class="search_results_guide-menu search_results"
>
  <div class="swiper guide-menu_search_results_swiper">
    <ul id="guide-menu_search_results_ul" class="swiper-wrapper">
      <li id="search_result_container" class="swiper-slide">
        <div class="search_result_container">
          <a class="link" href="/">
            <img class="ogp_image" src="/cmn/img/ogp_image_sample.svg" />
            <p class="title">タイトル</p>
          </a>
        </div>
      </li>
    </ul>
    <div class="guide-menu_swiper-scrollbar swiper-scrollbar"></div>
  </div>
  <div
    id="non-exist_search_results_guide-menu"
    class="non-exist_search_results"
  >
    <p>検索結果がありません。</p>
  </div>
  <div class="close_search_results_container">
    <a class="close_search_results" onclick="closeResults('guide-menu')">
      検索結果を閉じる ✕
    </a>
  </div>
</div>

          </div>
          <div class="guide-menu_sitepolicy_container">
            <link rel="stylesheet" href="${___HTML_LOADER_IMPORT_19___}" />
<ul class="sitepolicy-link">
  <li>
    <a href="/about/#insurance_inquiry" data-id="guide-menu_inquiry"
      >お問い合わせ一覧</a
    >
  </li>
  <li>
    <a
      href="/about/solicitation_policy/"
      data-id="guide-menu_solicitation-policy"
      >代理店勧誘方針について</a
    >
  </li>
  <li>
    <a href="/about/" data-id="guide-menu_site-guide"
      >お金のミカタについて</a
    >
  </li>
  <li>
    <a href="/about/sitemap/" data-id="guide-menu_sitemap"
      >サイトマップ</a
    >
  </li>
</ul>

          </div>
        </div>
      </div>
    </div>
  </nav>
  <link rel="stylesheet" href="${___HTML_LOADER_IMPORT_18___}" />
<div
  id="sub-menu_search_results"
  class="search_results_sub-menu search_results"
>
  <div class="swiper sub-menu_search_results_swiper">
    <ul id="sub-menu_search_results_ul" class="swiper-wrapper">
      <li id="search_result_container" class="swiper-slide">
        <div class="search_result_container">
          <a class="link" href="/">
            <img class="ogp_image" src="/cmn/img/ogp_image_sample.svg" />
            <p class="title">タイトル</p>
          </a>
        </div>
      </li>
    </ul>
    <div class="sub-menu_swiper-scrollbar swiper-scrollbar"></div>
  </div>
  <div
    id="non-exist_search_results_sub-menu"
    class="non-exist_search_results"
  >
    <p>検索結果がありません。</p>
  </div>
  <div class="close_search_results_container">
    <a class="close_search_results" onclick="closeResults('sub-menu')">
      検索結果を閉じる ✕
    </a>
  </div>
</div>

</header>
<!-- お知らせエリア（通常は非表示） -->
<link rel="stylesheet" href="${___HTML_LOADER_IMPORT_20___}" />

<dl id="info-top" class="red">
  <dt><span>重要なお知らせ</span></dt>
  <dd>
    <!--<b>10月22日</b>-->　
    現在、お金のミカタ内の一部サービスにおいて、セキュリティ対応等のためメンテナンスを実施しております。メンテナンス期間中は、対象となる一部サービスをご利用いただけない場合がございます。ご利用のお客様にはご不便をおかけし、申し訳ございません。ご理解いただきますよう、お願い申し上げます。
  </dd>
</dl>

<!--
<dl id="info-top">
    <dt><span>お知らせ</span></dt>
    <dd>
        <a href="https://www.finance.ponta.jp/campaign/risoku20220329/?from=info_risoku">＼Pontaポイント利息で増えるキャンペーン実施中／</a>
    </dd>
</dl>
-->


    <!-- NOTE: /common/Modal.jsをheadで読み込んでください -->
<link rel="stylesheet" href="${___HTML_LOADER_IMPORT_21___}" />

<div id="access-limit-modal" class="modal js-modal">
  <div class="modal__bg js-modal-close"></div>
  <div class="modal__content align-c">
    <p class="message">
      ただいまアクセスが集中しております。時間をおいてもう一度お試しください。
    </p>
    <a class="js-modal-click_close btn_orange">〇 はい</a>
  </div>
</div>
 
    <div class="body-contents">
      <main>
        <div class="bg-white risoku">
          <!-- キャンペーン期間前, お預け入れ申込期間終了のお知らせ -->
          <!-- システムメンテナンスのお知らせ -->
          <!--
          <dl class="attention attention-top attention-top-lt">
            <dt>システムメンテナンスのお知らせ</dt>
            <dd>
              <p>
                <strong>2023年3月29日(水) 10:00-17:00(予定)</strong>
                の間で、システムメンテナンスを実施いたします。<strong>期間中は、ポイント定期預金のお預入れができなくなります。</strong>ご不便をおかけいたしますが、あらかじめご了承いただけますようお願い申し上げます。
              </p>
            </dd>
          </dl>
          -->

          <!-- アクセス集中時のお知らせ -->

          <!-- <dl
            class="attention attention-top timer-target"
            data-start="2023-04-10T14:00+09:00"
          >
            <dt>お知らせ</dt>
            <dd>
              <p>
                現在アクセスが集中しお手続きしづらい状況です。<br />恐れ入りますが、しばらくお時間をおいてから、再度アクセス頂きますようお願い申し上げます。
              </p>
            </dd>
          </dl> -->

          <!-- 障害のお知らせ -->
          <!-- 
          <dl
            class="attention attention-top timer-target"
            data-start="2023-04-10T14:00+09:00"
          >
            <dt>お知らせ</dt>
            <dd>
              <p>
                アクセス集中により、受付システムに障害が発生しております。受付開始までもうしばらくお待ちください。
              </p>
            </dd>
          </dl> -->
          <dl
            class="attention attention-top timer-target"
            data-start="2023-12-22T18:00+09:00"
          >
            <dt>お知らせ</dt>
            <dd>
              <p>
                キャンペーンは終了いたしました。<br />
                ポイントのお戻しは2月中予定です。
              </p>
            </dd>
          </dl> 

          <section id="title" class="title">
            <h2>
              <img
                class="display-pc"
                src="${___HTML_LOADER_IMPORT_0___}"
                alt="Pontaポイントがかならず増える!!ポイント定期預金"
                width="750"
                height="400"
              />
              <img
                class="display-sp"
                src="${___HTML_LOADER_IMPORT_22___}"
                alt="Pontaポイントがかならず増える!!ポイント定期預金"
                width="1"
                height="1"
              />
            </h2>
            <p class="title_lead">
              <img
                src="/campaign/risoku20220920/img/title_lead.svg"
                alt="ためたPontaポイントの利用予定がない方必見！"
                width="600"
                height="67"
              />
            </p>
            <p class="title-description">
              一定期間お預け頂くだけで、
              <u>
                <b>ポイントが必ず増えて戻ってくる！</b>
              </u>
              <br />
              保有ポイントの有効期限も延長されちゃう簡単ポン活キャンペーン
            </p>
          </section>

          <!-- 以下のscriptを親で読み込んでください -->
<!-- ${"<" + "script"} type="text/javascript" src="/common/timer.js">${"<" + "/script"}> -->

<link
  rel="stylesheet"
  href="${___HTML_LOADER_IMPORT_23___}"
/>

<section class="risoku-entry">
  <!-- 読み込み時, 背景がshimmerになるエリア -->
  <div class="shimmer timer-target">
    <!-- 読み込み時, ローディングメッセージを表示 -->
    <div class="loading-message">
      <p>読み込み中</p>
      <span class="spinner"></span>
    </div>
    <!-- 読み込み時, visibility: hiddenになる -->
    <div class="hidden-when-loading">
      <div class="bg-light">
        <div class="entry-wrapper" id="entry">
          <div class="anchor-link">
            <a href="#overview">概要はこちら</a>
            <a href="#attention-sec">注意事項はこちら</a>
            <a href="#process">預入申し込み手順はこちら</a>
          </div>
          <!-- キャンペーン期間設定 -->
          
          <!---->
          
          <a
            class="entry-float-link timer-target"
            data-start="2023-12-04T10:30+09:00"
            data-end="2023-12-22T18:00+09:00"
            href="#entry"
          >
            今すぐお預入
          </a>
          <!---->
          <div class="entry_decoration">
            <link
  rel="stylesheet"
  href="${___HTML_LOADER_IMPORT_24___}"
/>

<div class="event_description">
  <div class="speech_balloon">
    <div class="inner_speech_balloon">
      <p>将来の日経平均株価の<br class="sp_display" />動きを予測しよう！</p>
      <br />
    </div>
    <img
      src="/campaign/risoku20231204/balloon-tail.svg"
      alt=" balloon-tail"
      class="balloon-tail"
      loading="lazy"
    />
  </div>
  <div class="question_text">
    <img
      src="/campaign/risoku20231204/icon_q.svg"
      alt=" 質問"
      class="question_mark"
      width="53px"
      height="69px"
      loading="lazy"
    />
    <div class="text-area">
      <p>
        2023年大納会<sup>*1</sup>の日経平均株価終値に対して、<br />
        2024年大発会<sup>*2</sup>の日経平均株価終値は<span class="up"
          >上がる？</span
        ><span class="down">下がる？</span>
      </p>
      <br />
      <p class="attention">*1：年の最後の取引日　*2：年の初めの取引日</p>
      <!-- 正解エリアここから（発表時に表示） -->
      <dl class="answer">
        <dt>
          <span class="label">正解は…</span><span>Bコース（下がる）</span>
        </dt>
        <dd>
          2023年大納会の日経平均株価終値は3万3464円17銭でした。2024年大発会の日経平均株価終値は3万3288円29銭となり、大納会に対して175円88銭安となったためBコースが正解です。
        </dd>
        <hr />
        <dd class="result">
          <span class="label">結果</span><span>Aコース：3%　Bコース：5%</span>
        </dd>
      </dl>
      <!-- 正解エリアここまで -->
    </div>
  </div>
</div>


          </div>
          <ul class="entry-button-ul">
            <!-- isLimited:true にすると 「受付上限到達」になる -->
            <li>
              <!--<span class="badge">10,000名追加！</span>-->
              <link
  rel="stylesheet"
  href="${___HTML_LOADER_IMPORT_25___}"
/>


<!-- ↑ のisLimitedはtrueのままでよい -->

<!-- (_entry_section.ejsの)limitedがtrueの場合はタイマーがオフになり、"disabled"固定になる -->
<a
  class="modal-trigger-button risoku-entry-button-component timer-target  course_A"
  data-start="2023-12-04T10:30+09:00"
  data-end="2023-12-22T18:00+09:00"
  data-url="/risoku/entry?campaign_code=W1wIRl&amp;from=risoku_20231204_a"
  data-id="risoku_20231204_a"
  disabled
>
  <img
    src="/campaign/risoku20231204/icon_arrow-up.svg"
    alt="arrow-up"
    class="arrow-up"
  />
  <p class="course_name">
    Aコース
    <small> (上がる) </small>
  </p>
  <p class="input-point">100P : 3%</p>
  <div class="status-message-container">
    <span class="status-message message-point">
      103P お戻し
    </span>
    <!---->
    
    <span class="status-message message-upcoming"> 受付期間前</span>
    <span class="status-message message-finished"> 受付終了</span>
  </div>
</a>

            </li>
            <li>
              <!--<span class="badge">5,000名追加！</span>-->
              <link
  rel="stylesheet"
  href="${___HTML_LOADER_IMPORT_25___}"
/>


<!-- ↑ のisLimitedはtrueのままでよい -->

<!-- (_entry_section.ejsの)limitedがtrueの場合はタイマーがオフになり、"disabled"固定になる -->
<a
  class="modal-trigger-button risoku-entry-button-component timer-target  course_B"
  data-start="2023-12-04T10:30+09:00"
  data-end="2023-12-22T18:00+09:00"
  data-url="/risoku/entry?campaign_code=l63INx&amp;from=risoku_20231204_b"
  data-id="risoku_20231204_b"
  disabled
>
  <img
    src="/campaign/risoku20231204/icon_arrow-down.svg"
    alt="arrow-down"
    class="arrow-down"
  />
  <p class="course_name">
    Bコース
    <small> (下がる) </small>
  </p>
  <p class="input-point">100P : 3%</p>
  <div class="status-message-container">
    <span class="status-message message-point">
      103P お戻し
    </span>
    <!---->
    
    <span class="status-message message-upcoming"> 受付期間前</span>
    <span class="status-message message-finished"> 受付終了</span>
  </div>
</a>

            </li>
          </ul>
          <div class="up_rate_notice">
            <img src="/campaign/risoku20231204/copy_pointup.svg"/>
          </div>
          <div class="application_attention">
            <p>どちらか1コースを、1回のみお申し込み頂けます。</p>
            <small>
              <p>※お申し込み後の変更・キャンセルはできません。</p>
              <p>※お申し込み完了後、大和コネクト証券のキャンペーンページに遷移します。</p>
            </small>
          </div>
          <div
            class="term timer-target"
          >
            <span>預入申し込み期間: </span>
            <span>12月4日(月) 11:00～12月22日(金) 18:00</span>
          </div>
        </div>
        <link
  rel="stylesheet"
  href="${___HTML_LOADER_IMPORT_26___}"
/>

<div class="deposit_info_title">
  <p>預入募集概要</p>
</div>
<dl class="requirements-table">
  <div class="limit">
    <dt>申し込み上限数<br>(各月毎)</dt>
    <dd>
      <p>Aコース・Bコース</p>
      <p>合計5万名まで</p>
      <p class="annotation">※どちらか1コースを、</br>一回のみ申し込み可</p>
    </dd>
  </div>
  <div class="period">
    <dt>正解発表日</dt>
    <dd>2024年大発会の</br>翌日以降</dd>
  </div>
  <div class="return-date">
    <dt>お戻し予定日</dt>
    <dd>
      <p>2024年2月中</p>
      <p class="annotation">
        ※申し込み日時により、</br>
        お戻し日は異なります。
      </p>
    </dd>
  </div>
</dl>

      </div>

    <!-- お預入れ状況リンク停止中 -->
    <!--
    <a
      data-id="risoku20230123_check-button"
      class="check-status timer-target"
      href="https://www.finance.ponta.jp/risoku/entry?check=y"
      data-start="2023-01-23T10:59+09:00"
      data-end="2023-06-30T18:00+09:00"
      target="_blank"
    >
      お預け入れ状況のご確認
    </a>
    -->

</section>

<!-- NOTE: /common/Modal.jsをheadで読み込んでください -->
<link rel="stylesheet" href="${___HTML_LOADER_IMPORT_21___}" />

<div id="access-limit-modal" class="modal js-modal">
  <div class="modal__bg js-modal-close"></div>
  <div class="modal__content align-c">
    <p class="message">
      ただいまアクセスが集中しております。時間をおいてもう一度お試しください。
    </p>
    <a class="js-modal-click_close btn_orange">〇 はい</a>
  </div>
</div>


          <br />
          <link rel="stylesheet" href="${___HTML_LOADER_IMPORT_27___}" />

<div class="sns_share">
  <p>シェアをする</p>
  <div>
    <a
      class="facebook"
      href="http://www.facebook.com/share.php?u=https://www.finance.ponta.jp/campaign/risoku20231204/?from=facebook_risoku20231204"
      target="_blank"
      rel="noopener"
    ></a>
    <a
      class="x"
      href="https://x.com/share?url=https://www.finance.ponta.jp/campaign/risoku20231204/?from=x_risoku20231204&hashtags=ポンタ,Ponta,ポン活,かならず増える,期間限定,先着,拡散希望"
      target="_blank"
      rel="noopener"
    ></a>
    <a
      class="line"
      href="https://social-plugins.line.me/lineit/share?url=https://www.finance.ponta.jp/campaign/risoku20231204/?from=line_risoku20231204"
      target="_blank"
      rel="noopener"
    ></a>
    <a
      class="mail"
      href="mailto:?body=https://www.finance.ponta.jp/campaign/risoku20231204/?from=mail_risoku20231204"
      target="_blank"
      rel="noopener"
    ></a>
  </div>
</div>


          <section id="overview" class="overview">
            <h3 class="balloon">キャンペーン概要</h3>
            <div id="overview_image">
              <p>
                <img
                  class="display-pc"
                  src="${___HTML_LOADER_IMPORT_28___}"
                  alt="ポイントを預けて...お預かり期間待つだけで...利息分が“必ず増えて”戻ってくる！"
                  width="840"
                  height="407"
                  loading="lazy"
                />
                <img
                  class="display-sp"
                  src="${___HTML_LOADER_IMPORT_29___}"
                  alt="ポイントを預けて...お預かり期間待つだけで...利息分が“必ず増えて”戻ってくる！"
                  width="28"
                  height="81"
                  loading="lazy"
                />
              </p>
              <p>
                <img
                  class="copy-message"
                  src="/campaign/risoku20231204/copy_chance.svg"
                  alt=" お預け入れの受付は期間限定！最大利息5%のお試しポイント定期預金"
                  loading="lazy"
                />
                <img
                  class="pointup_overlap"
                  src="/campaign/risoku20231204/copy_pointup.svg"
                  alt=" 正解コースは利率3%→5%にUP!"
                  loading="lazy"
                />
              </p>
            </div>
            <div class="application_attention">
              <p>どちらか1コースを、1回のみお申し込み頂けます。</p>
              <small>
                <p>※お申し込み後の変更・キャンセルはできません。</p>
                <p>※お申し込み完了後、大和コネクト証券のキャンペーンページに遷移します。</p>
              </small>
            </div>
            <p class="main-description">
              本キャンペーンは、Pontaポイントを⼀定期間預⼊ると、利息でポイントが<u><b>“必ず増える”</b></u>2コース制の懸賞付き定期預金です。 
              <br>どちらのコースに申し込んでも、
               100ポイントをお預かりして一定期間後に3％の利息ポイントを付けてお戻しします。
               <br>2023年の大納会に対して、2024年の大発会の日経平均が上がるか下がるかを予想して、
               正解のコースに申し込んだ方には2%追加した5%の利息ポイントを付けてお戻しします。
            </p>
          <link
  rel="stylesheet"
  href="${___HTML_LOADER_IMPORT_30___}"
/>

<a href="/campaign/risoku20231204/#" class="ui-parts-categorylist-link"
  >ページTOPに戻る ▲</a
>

          <section id="process" class="process">
            <a class="anchor" id="process-a"></a>
            <h3>預入申し込み手順</h3>
            <h4>Step 1：エントリー</h4>
            <dl class="process">
              <dt>
                <img
                  src="${___HTML_LOADER_IMPORT_31___}"
                  alt="エントリーボタン"
                  width="425"
                  height="240"
                  loading="lazy"
                />
              </dt>
              <dd>
                注意事項をお読みの上、お預入申し込みボタンより手続きをします。
              </dd>
            </dl>
            <h4>Step 2：ログイン</h4>
            <dl class="process">
              <dt>
                <img
                  src="/campaign/risoku20220920/img/step2.png"
                  alt="ログイン画面"
                  width="37"
                  height="21"
                  loading="lazy"
                />
              </dt>
              <dd>
                ログイン画面より該当の形式でログインください。<br />Ponta
                カードをまだ作成していないお客様は新規会員登録後、ログインください。
              </dd>
            </dl>
            <!--
            <h5 class="process-attention">注意</h5>
            <dl class="process process-attention">
              <dt><img src="/campaign/risoku20220920/img/step2-attention.png" alt="ログイン時のご注意" /></dt>
              <dd>
                「PontaWebでログイン/新規登録」を選択されたお客様で、PontaWeb会員登録がお済みの方は、「ログイン」ボタンよりエントリーを行ってください。<br>
                Pontaカードをお持ちでPontaWeb会員登録がお済みでないお客様は、Pontaカードに書かれたPonta会員IDをご入力後「次へ」ボタンを押してください。
              </dd>
            </dl>
            -->
            <h4>Step 3：お預入申し込み</h4>
            <dl class="process">
              <dt>
                <img
                  src="${___HTML_LOADER_IMPORT_32___}"
                  alt="お預け入れ申込画面"
                  width="407"
                  height="248"
                  loading="lazy"
                />
              </dt>
              <dd>
                ポイント預入手続き画面にてポイント残高・預入ポイントをご確認の上、決定ボタンを押してください。
              </dd>
            </dl>
            <h4>Step 4：お預入完了</h4>
            <dl class="process">
              <dt>
                <img
                  src="${___HTML_LOADER_IMPORT_33___}"
                  alt="お預け入れ完了画面"
                  width="284"
                  height="145"
                  loading="lazy"
                />
              </dt>
              <dd>
                完了画面が表示されます。内容をご確認いたしましたら閉じるボタンを押してください。
                <br /><br />
                ※お預入内容のご確認は、<a
                  href="https://point.recruit.co.jp/point/pwbBalanceRef/"
                  target="_blank"
                  rel="noopener"
                  data-id="risoku20230123_pontaweb-point"
                  class="underline"
                  >PontaWebのポイント通帳</a
                >および
                <a
                  href="https://www.point-portal.auone.jp/point/history"
                  target="_blank"
                  rel="noopener"
                  data-id="risoku20230123_pontaweb-point"
                  class="underline"
                  >au Pontaポータルのポイント履歴</a
                >
                にてご確認いただけます。<br />
                ※お申し込み完了後、大和コネクト証券のキャンペーンページに遷移します。
              </dd>
            </dl>
            <!--
            <dl class="attention">
              <dt>ご注意ください</dt>
              <dd>
                <p>お預け入れ(減算)は4/26(火)12:00～23:59の間に行われます。
                <span class="red">この時点でPontaポイント残高を<span class="big">100</span>ポイント以上にしてください。</span></p>
                <p>減算時の残高が100Pontaポイント未満の場合、本キャンペーンのエントリーはキャンセルとなります。
                <span class="red">また、一時的にポイント残高がマイナス表示となりPontaポイントの利用（つかう）ができなくなる場合がございます。</span></p>
              </dd>
            </dl>
            -->
            <h4>Step 5：お預入ポイントと利息のお戻し</h4>
            <dl class="process">
              <dt>
                <img
                  src="${___HTML_LOADER_IMPORT_34___}"
                  alt="利息分加算"
                  width="142"
                  height="47"
                  loading="lazy"
                />
              </dt>
              <dd>
                2024年2月中に、お客様のポイント残高にお預かりしたポイントと利息分のポイントが加算されます。<br /><br />
                ※加算されるポイントは、通常ポイントです。加算後、お持ちの通常ポイントの有効期限が1年に延長されます。
              </dd>
            </dl>
          </section>
          <link
  rel="stylesheet"
  href="${___HTML_LOADER_IMPORT_30___}"
/>

<a href="/campaign/risoku20231204/#" class="ui-parts-categorylist-link"
  >ページTOPに戻る ▲</a
>

          <section id="attention-sec" class="attention-sec">
            <a class="anchor" id="attention-sec-a"></a>
            <h3>注意事項</h3>
            <ul>
              <li>※以下のポイントはPontaポイントを指します。</li>
              <li>
                ※以下の⽇程はすべて⼟⽇祝および当社が規定する休業⽇を除く営業⽇とします。
              </li>
            </ul>
            <ol>
              <li>
                お申し込みと同時に預入るポイント数が減算され、お預入が完了します。
              </li>
              <br />
              <li>
                お預入申し込み時に必要ポイント以上をお持ちでない⽅は、本キャンペーンをお申し込みいただけません。お預入受付期間中に必要ポイントご用意の上、再度お申込みください。
              </li>
              <br />
              <li>
                お預入は、おひとり様1回限り有効です。お預かり後のキャンセルはできませんので、
                ポイントお戻し予定日までお待ち下さい。
              </li>
              <br />
              <li>
                お預入は、おひとり様どちらかのコース1回限り有効です。お預かり後のキャンセル、コース変更はできませんので、ポイントお戻し予定日までお待ち下さい。
              </li>
              <br />
              <li>
                受付はAコース・Bコース合計で先着50,000名様までとし、上限に達した場合は受付期間を早期に終了します。
              </li>
              <br />
              <li>
                キャンペーンへの参加状況（お預⼊(減算)ポイントやお戻し(加算)ポイント）は、<a
                  href="https://point.recruit.co.jp/point/pwbBalanceRef/"
                  target="_blank"
                  class="underline"
                  >PontaWebのポイント通帳</a
                >および<a
                  href="https://www.point-portal.auone.jp/point/history"
                  target="_blank"
                  class="underline"
                  >au Pontaポータルのポイント履歴</a
                >にてご確認いただけます。
              </li>
              <br />
              <!--
              <li>
                キャンペーンへの参加状況については、本ページ内の「お預け入れ状況のご確認」ボタンまたは、
                <a
                  href="https://www.finance.ponta.jp/risoku/entry?check=y"
                  target="_blank"
                  class="timer-target status-check-link"
                  data-start="2023-01-23T10:00+09:00"
                  data-end="2023-06-30T18:00+09:00"
                  data-id="risoku20230123_check-textlink"
                >
                  こちら
                </a>
                よりご確認いただけます。
              </li>
              -->
              <li>
                「PontaWebでログイン」または、「au
                IDでログイン」のどちらかでお申し込みいただけます。ログインには、PontaWeb会員登録または、au
                ID連携が必要です。
              </li>
              <br />
              <!-- <li>
                お預け⼊れ(減算)ポイントや加算ポイントは、<a
                  href="https://point.recruit.co.jp/point/pwbBalanceRef/"
                  target="_blank"
                  rel="noopener"
                  data-id="risoku20230123_pontaweb-point"
                >
                  PontaWebのポイント通帳
                </a>
                および
                <a
                  href="https://www.point-portal.auone.jp/point/history"
                  target="_blank"
                  rel="noopener"
                  data-id="risoku20230123_auid-point"
                >
                  au ID会員サイトのPontaポイント獲得利⽤履歴 </a
                >にてご確認いただけます。
              </li> -->
              <li>
                お預入申し込み〜預入ポイントと利息ポイントの加算までに以下の条件に当てはまった場合、預⼊ポイントや利息ポイントまたはその両⽅を受ける権利を失います。
                <p>
                  (1)お預入申込の手続きを最後まで正しく完了せず、
                  『PontaWebのポイント通帳』または『au
                  ID会員サイトのPontaポイント獲得利⽤履歴』にてお預かりポイントが表示されない方<br />
                  (2)Pontaを退会された場合<br />
                  (3)Ponta会員IDの登録内容に虚偽・不備がある場合<br />
                  [PontaWebでお預入申し込みをされた場合]<br />
                  (1)リクルートIDを退会された場合<br />
                  (2)PontaWeb会員登録(Ponta会員IDの登録)が⾏われていない場合<br />
                  [au IDでお預入申し込みをされた場合]<br />
                  (1)au IDの連携を解除された場合<br />
                  (2)au IDの連携が⾏われていない場合<br />
                </p>
              </li>
              <br />
              <li>
                本キャンペーンの内容は、事前の告知なく変更、または終了させていただく場合がありますので、予めご了承願います。
              </li>
              <br />
              <li>
                その他、(株)ロイヤリティ
                マーケティング、(株)リクルート、KDDI(株)が不正とみなしたPonta会員は対象外とさせていただく場合がございます。
              </li>
              <br />
              <li>
                システム障害やシステムメンテナンス、その他の理由で一時的にお申し込みできない場合や、ポイント減算及びポイント加算が遅れる場合がございます。
              </li>
              <br />
              <li>インターネット通信料、接続料はお客様のご負担となります。</li>
              <br />
              <li>
                ご利⽤の端末や環境等により、ページが正しく表⽰されない場合があります。
              </li>
              <br />
              <li>
                通信回線の状態による遅延、不具合などにより本キャンペーンへのアクセスや登録・表⽰などができないことにより発⽣した損害、またはそれに起因して発⽣したすべての事象につきましては、
                原因の如何によらず⼀切の責任を負いかねますので、その旨ご了承の上ご利⽤願います。
              </li>
              <br />
              <li>
                本キャンペーンにご参加頂いたPonta会員には、利息ポイント加算後に本キャンペーンに関するアンケートを、ご登録のメールアドレスにお送りさせて頂く場合があります。
              </li>
            </ol>
            <!--
            <dl class="attention">
              <dt>ご注意ください</dt>
              <dd>
                <p>お預け入れ(減算)は4/26(火)12:00～23:59の間に行われます。
                  <span class="red">この時点でPontaポイント残高を<span class="big">100</span>ポイント以上にしてください。</span></p>
                <p>減算時の残高が100Pontaポイント未満の場合、本キャンペーンのエントリーはキャンセルとなります。
                <span class="red">また、一時的にポイント残高がマイナス表示となりPontaポイントの利用（つかう）ができなくなる場合がございます。</span></p>
              </dd>
            </dl>
          --></section>

          <link
  rel="stylesheet"
  href="${___HTML_LOADER_IMPORT_30___}"
/>

<a href="/campaign/risoku20231204/#" class="ui-parts-categorylist-link"
  >ページTOPに戻る ▲</a
>

          <!---->
          <!--
  使い方例
  include("/common/ui-parts/_breadcrumbs.ejs", {label:["ホーム", "新しいページ"], href=["/", "/new-page"]})
-->


<!---->

<link rel="stylesheet" href="${___HTML_LOADER_IMPORT_35___}" />

<nav id="pankuzu">
  <ul>
    
      <li><a href="/">ホーム</a></li>
    
    <li>Pontaポイント定期預金キャンペーン</li>
  </ul>
</nav>

        </div>        
      </main>
    </div>
    <link rel="stylesheet" href="${___HTML_LOADER_IMPORT_36___}" />
<div id="footer-address">
  <!-- 戻るリンク -->
  <div id="pagetop">
    <a href="#"
      ><img
        src="/cmn/img/top_ponta.svg"
        alt="TOPへ戻る"
        width="69"
        height="89"
        loading="lazy"
    /></a>
  </div>
  <div class="footer-address-wrapper">
    <address id="address_top">
      保険取扱代理店：株式会社 ロイヤリティマーケティング<br />
      〒150-0013　東京都渋谷区恵比寿1-18-14 恵比寿ファーストスクエア 7階
    </address>
    <p>
      このホームページは、各保険商品の概要についてご紹介しております。<br />
      補償内容の確認やご契約及びご加入にあたっては、各保険商品のリンク内をご確認ください。
    </p>
    <link rel="stylesheet" href="${___HTML_LOADER_IMPORT_19___}" />
<ul class="sitepolicy-link">
  <li>
    <a href="/about/#insurance_inquiry" data-id="footer_inquiry"
      >お問い合わせ一覧</a
    >
  </li>
  <li>
    <a
      href="/about/solicitation_policy/"
      data-id="footer_solicitation-policy"
      >代理店勧誘方針について</a
    >
  </li>
  <li>
    <a href="/about/" data-id="footer_site-guide"
      >お金のミカタについて</a
    >
  </li>
  <li>
    <a href="/about/sitemap/" data-id="footer_sitemap"
      >サイトマップ</a
    >
  </li>
</ul>

  </div>
</div>
<footer id="FOOTER" class="footer">
  <ul>
    <li>
      <a
        href="https://policy.ponta.jp/c/privacy/index3.htm?from=footer_technology"
        data-id="footer_technology"
        target="_blank"
        rel="noopener"
        >利用技術及び外部送信ポリシー</a
      >
    </li>
    <li>
      <a
        href="https://www.ponta.jp/c/dpc/?from=footer_ponta-app"
        data-id="footer_ponta-app"
        target="_blank"
        rel="noopener"
        >Pontaアプリ</a
      >
    </li>
    <li>
      <a
        href="https://www.loyalty.co.jp/?from=footer_company"
        data-id="footer_company"
        target="_blank"
        rel="noopener"
        >運営会社</a
      >
    </li>
  </ul>
  <p class="copy">©Ponta</p>
</footer>

  </body>
</html>
`;
// Exports
export default code;